/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef } from 'react';

import Img from '../../Img';
import Popup from '../../Popup';
import RatingInfoContent from './RatingInfoContent';
import RangeInfoContent from './RangeInfoContent';
import PickleballRatingInfoContent from './PickleballRatingInfoContent';

import styles from './ratingInfo.scss';

const RatingInfoNew = (props) => {
    const { isMobile, type = 'ratingInfo', cancelText } = props;
    const [showPopup, setShowPopup] = useState();
    const [displayMenuBelowAnchor, setDisplayMenuBelowAnchor] = useState(true);
    const [hoverWidth, setHoverWidth] = useState(true);
    const [rightAlign, setRightAlign] = useState(true);
    const wrapperRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setShowPopup(false);
        }
    };

    const handleAchorClick = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();

        // width reduced for Iphone 5 and small resolution devices
        let width = '90vw';
        if (window.innerWidth > 500) {
            width = 500;
        }

        let right = false;
        if (ev.nativeEvent.clientX > window.innerWidth / 2) {
            right = true;
        }

        setShowPopup(true);
        setDisplayMenuBelowAnchor(true);
        setHoverWidth(`${width}px`);
        setRightAlign(right);
    };

    const closePopUp = () => {
        setShowPopup(false);
    };

    const getContent = () => {
        if (type === 'pickleball') {
            return (
                <PickleballRatingInfoContent
                    isMobile={isMobile}
                    cancelText={cancelText}
                    closePopUp={closePopUp}
                />
            );
        }
        if (type === 'ratingInfo') {
            return (
                <RatingInfoContent
                    isMobile={isMobile}
                    cancelText={cancelText}
                    closePopUp={closePopUp}
                />
            );
        }
        return (
            <RangeInfoContent
                isMobile={isMobile}
                cancelText={cancelText}
                closePopUp={closePopUp}
            />
        );
    };

    const DesktopPopup = () => {
        return (
            <div className={`rating-pop-up`}>
                {getContent()}
            </div>
        );
    };

    const MobilePopup = () => (
        <Popup
            className={`popup-md clear-over-flow`}
            onCloseClick={closePopUp}
            config={{
                noPadding: false,
                fullScreen: false,
                topGradient: false,
                scrollable: true,
                noHeader: true,
                style: {
                    overflowY: 'scroll',
                },
            }}
        >
            {getContent()}
        </Popup>
    );

    return (
        <div className={`${styles.ratingInfo} info-root ${props.rootClass ? props.rootClass : ''}`} ref={wrapperRef}>
            <Img
                alt="tooltip"
                src={props.infoIcon || '/img/info-icon.svg'}
                className={`info-anchor ${props.anchorClass ? props.anchorClass : ''}`}
                onClick={handleAchorClick}
            />
            {showPopup && (
                <div className="action-click-disabler" />
            )}
            {isMobile && showPopup && (
                <MobilePopup />
            )}
            {!isMobile && (
                <div
                    className={`info-container ${displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'} ${props.menuClass ? props.menuClass : ''}`}
                    style={rightAlign ? {
                        width: hoverWidth,
                        right: '0',
                    } : {
                        width: hoverWidth,
                        left: '0',
                    }}
                >
                    {showPopup && (
                        <DesktopPopup />
                    )}
                </div>
            )}
        </div>

    );
};

export default RatingInfoNew;
